// apps/web/src/services/clientUsersService.js

import { api } from './api'

export const getClientUsers = async (clientId) => {
  const url = clientId ? `/client-users?clientId=${clientId}` : '/client-users'
  return api.get(url)
}

export const createClientUser = async (payload) => {
  return api.post('/client-users', payload)
}

export const updateClientUser = async (id, payload) => {
  return api.patch(`/client-users/${id}`, payload)
}

export const deleteClientUser = async (id) => {
  return api.delete(`/client-users/${id}`)
}